import { useEffect } from 'react'
import UserService from '../services/user.service'


const useGetUserTableSchema = (clientId, dataTableSchema, setUserDataTableSchema) => {    
    useEffect(()=> {
        const getDataAndSchema = async (client_id) => {
            const serviceResponse = await UserService.getPagedUsers(client_id, dataTableSchema.pageNumber, dataTableSchema.pageSize, dataTableSchema.filters, dataTableSchema.orderField, dataTableSchema.orderAsc);
            const response = serviceResponse.data;

            setUserDataTableSchema(response);
        }
         
        if (dataTableSchema === null || dataTableSchema.data === null) {
            getDataAndSchema(clientId)
        }
    }, [clientId, dataTableSchema, setUserDataTableSchema]);
}
 
export { useGetUserTableSchema }